import { render } from "./App.vue?vue&type=template&id=bc4da57e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bc4da57e&lang=css"

import exportComponent from "L:\\WEB\\burgimspreewald-ticketscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__